<script>
  import { onMount } from "svelte";
  let { card } = $props();
  let baseurl = "/";
  let items = void 0;
  onMount(() => {
    baseurl = window.location.pathname;
    if (card && card.tags && typeof card.tags === "string") {
      items = card.tags.split(";");
    }
  });
</script>

<div class="wc-apl-card-container">
  <div class="wc-card__image sixteen-by-nine">
    <img src={card.imageSrc} alt={card.imageAlt} class="" />
  </div>
  {#if card.category}
    <div class="wc-apl-container__tag">
      {card.articleType}
      <span class="mx-4">•</span>
      <span class="category-tags">{card.category}</span>
    </div>
  {/if}

  <h4 class="wc-apl-container__main-text">
    <a class="font-light text-river" href={card.linkUrl}>
      {card.linkText}
    </a>
  </h4>
</div>
